export function convertDateFormat(dateString: string) {
    const dateParts = dateString.split("/");
    const convertedDate = dateParts.join("-");
    return convertedDate;
}
